export const FLASHCARD_REVIEW_RECORDED_EVENT = 'teachmenow:flashcard-review-recorded' as const;
export const POINTS_UPDATED_EVENT = 'teachmenow:points-updated' as const;

export interface FlashcardReviewRecordedDetail {
  flashcardId: number;
}

declare global {
  interface WindowEventMap {
    [FLASHCARD_REVIEW_RECORDED_EVENT]: CustomEvent<FlashcardReviewRecordedDetail>;
    [POINTS_UPDATED_EVENT]: Event;
  }
}

export const emitPointsUpdated = (): void => {
  window.dispatchEvent(new Event(POINTS_UPDATED_EVENT));
};

export const emitFlashcardReviewRecorded = (flashcardId: number): void => {
  window.dispatchEvent(
    new CustomEvent<FlashcardReviewRecordedDetail>(FLASHCARD_REVIEW_RECORDED_EVENT, {
      detail: { flashcardId },
    }),
  );
  emitPointsUpdated();
};
